import connectLoadingPage from './connectLoadingPage';
import LoadingPage from './LoadingPage';

export default connectLoadingPage(LoadingPage);
